import { render, staticRenderFns } from "./WeightGainOfDifferentSource.vue?vue&type=template&id=198d26c8&scoped=true&"
import script from "./WeightGainOfDifferentSource.vue?vue&type=script&lang=js&"
export * from "./WeightGainOfDifferentSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198d26c8",
  null
  
)

export default component.exports